<template>
  <div class="position-relative task-tag">
    <div class="task-tag__circle" :style="`background-color: ${this.color}`">
      <div :class="`position-absolute task-tag__title`" :style="`background-color: ${this.color}`">{{ tag.title }}</div>
    </div>
  </div>
</template>
<script>
export default{
  props:{
    tag: Object
  },
  methods:{
  },
  computed: {
    classVisible: function(){
      return this.titleVisible ? 'visible' : '';
    },
    color: function(){
      return this.tag.color.hex_rgb_code
    }
  }
}
</script>
